import { NgClass } from '@angular/common';
import { Component, input, signal } from '@angular/core';

@Component({
  imports: [NgClass],
  selector: 'avs-instance-badge',
  templateUrl: './instance-badge.component.html',
})
export class InstanceBadgeComponent {
  minified = input(false);
  instance = signal('');

  constructor() {
    this.instance.set(this.getInstance());
  }

  private getInstance() {
    const host = location.host;

    switch (true) {
      case host.includes('localhost'):
      case host.includes('dev.'):
        return 'dev';
      case host.includes('stage.'):
        return 'stage';
      default:
        return '';
    }
  }
}
